import React, { useEffect, useRef } from "react";
import { RxCross2 } from "react-icons/rx";

const RightSidebar = ({
  isOpen = false,
  onClose,
  title,
  content,
  width = null,
}) => {
  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleCloseSidebar = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleCloseSidebar);
    return () => {
      document.removeEventListener("mousedown", handleCloseSidebar);
    };
  }, [onClose]);

  return (
    <div
      ref={sidebarRef}
      className={`fixed top-0 right-0 h-full ${
        width ? width : "w-[50%]"
      } flex flex-col bg-white shadow-lg border-l border-gray-200 overflow-y-auto z-50 transition-transform duration-700 ease-in-out ${
        isOpen ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="flex p-3 z-30 items-center shadow-sm border-b w-full sticky top-0 bg-white gap-10">
        <button onClick={onClose}>
          <RxCross2 className="text-xl" />
        </button>
        <div className="font-semibold text-base">{title}</div>
      </div>
      <div className="p-4 overflow-auto">{content}</div>
    </div>
  );
};

export default RightSidebar;
